import Icon from '../components/Icon.vue'

Icon.register({
  'basketball-ball': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M212.3 10.3C168.5 16.6 126.1 34.4 90.1 64.1L167.5 141.5C195.3 105.7 210.8 60.3 212.3 10.3zM248 222L405.9 64.1C363.5 29.1 312.3 10.6 260.4 8 259.2 71.9 238.9 130.3 201.7 175.7L248 222zM56.1 98.1C26.4 134.1 8.6 176.5 2.3 220.3 52.3 218.8 97.8 203.3 133.5 175.5L56.1 98.1zM328.3 302.3C373.6 265.2 432 244.9 496 243.6 493.4 191.7 474.9 140.5 439.9 98.1L282 256 328.3 302.3zM248 290L90.1 447.9C132.5 482.8 183.7 501.4 235.6 504 236.9 440 257.2 381.6 294.3 336.3L248 290zM439.9 413.9C469.6 377.9 487.4 335.5 493.7 291.7 443.6 293.3 398.2 308.8 362.5 336.5L439.9 413.9zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4 2.6 320.3 21.1 371.5 56.1 413.9L214 256 167.7 209.7zM283.7 501.7C327.5 495.4 369.9 477.6 405.9 447.9L328.5 370.5C300.8 406.2 285.3 451.7 283.7 501.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/basketball-ball.js
// module id = 7hQg
// module chunks = 144